var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1823 15.1328L23.0001 21.6719M10.122 17.3125C11.2163 17.3125 12.2999 17.1058 13.3108 16.7041C14.3218 16.3025 15.2405 15.7138 16.0142 14.9716C16.788 14.2295 17.4018 13.3484 17.8206 12.3788C18.2394 11.4091 18.4549 10.3699 18.4549 9.32031C18.4549 8.27076 18.2394 7.23149 17.8206 6.26183C17.4018 5.29218 16.788 4.41113 16.0142 3.66898C15.2405 2.92684 14.3218 2.33814 13.3108 1.93649C12.2999 1.53485 11.2163 1.32812 10.122 1.32813C7.91195 1.32813 5.79244 2.17016 4.22972 3.66898C2.66699 5.16781 1.78906 7.20065 1.78906 9.32031C1.78906 11.44 2.66699 13.4728 4.22972 14.9716C5.79244 16.4705 7.91195 17.3125 10.122 17.3125Z",
    stroke: "#ED1C25",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2db59ebc89b3f16b7e3cf76082f88945.svg";
export { ForwardRef as ReactComponent };